module.exports = __webpack_public_path__ + "img/empty.16be1769.png";